import React from 'react';
import { connect } from 'react-redux';

import Sticky from 'Components/Sticky';
import ActionLoader from 'Components/ActionLoader';
import Sidebar from 'Components/Sidebar';
import DashboardTopNav from 'Components/DashboardTopNav';
import AllRfqs from 'Components/AllRfqs/Transporters';
import { GET_RFQS, CREATE_RFQ_SUCCESS, CLEAR_RFQS, PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE, PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE, GET_SERVICE_CATEGORY, UPDATE_SERVICE_CATEGORY, GET_RFQ_TYPES, POST_WISHLIST_EVENT } from 'Constants/actionConstants';
import { TRANSPORTER } from 'Constants/commonConstants';
import Moment from 'moment';
import { debounce, getUser } from 'Utils/storage';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import { getItemFromLocal } from 'Utils/localStorage';
import ScreenTimeTrack from "Components/Common/ScreenTimeTrack/index";
import { screenInfoDetails } from 'Constants/screenInfoDetailsConstants';
class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.user = getUser();
        const params = new URLSearchParams(props.location.search);
        const restoredSearch = params.get('search') || '';
        const restoredTab = params.get('tab') ? +params.get('tab') : null;
        this.state = {
            rfqStatusFilter : restoredTab || (props && props.match && props.match.params && props.match.params.id && +props.match.params.id) || 2,
            searchString: restoredSearch,
            offset: 0,
            limit: 10,
            data: props.rfqs.data || [],
            startDate:0,
            endDate:0,
            downlaadSCUrl: '',
            confirmationData: '',
            rfqTypesList: ''
        }
        this.onBasedDateSearchRfq = this.onRfqSearchByDate.bind(this);
        this.changeRfqStatusFilter = this.changeRfqStatusFilter.bind(this);
        this.onSearchStringChange = this.onSearchStringChange.bind(this);
        this.onKeyPressOnSearch = this.onKeyPressOnSearch.bind(this);
        this.onClearSearch = this.onClearSearch.bind(this);
        this.search = this.search.bind(this);
        this.goToNextPage = this.goToNextPage.bind(this);
        this.goToPrevPage = this.goToPrevPage.bind(this);

        this.debouncedSearch = debounce(this.search.bind(this), 1000);
        // Search term actually sent to the API - only updated when the input has 0 or >= 3 characters
        this.appliedSearch = restoredSearch.length >= 3 ? restoredSearch : '';

    }
    getRFQTimer = null;
    search(withOffset) {
        if(this.unmounted) {return};
        if(this.getRFQTimer) {
            clearTimeout(this.getRFQTimer)
        }
        const { dispatch } = this.props;
        const { offset, limit, rfqStatusFilter, startDate, endDate, rfqType } = this.state;
        if(rfqStatusFilter == 88) {
            if(this.getRFQTimer) {
                clearTimeout(this.getRFQTimer);
            }
            this.getServiceCategory();
        } else {
            dispatch({
                type: GET_RFQS,
                params: {
                    offset: withOffset > 0 ? offset : 0,
                    limit: limit,
                    type: rfqStatusFilter,
                    search: this.appliedSearch,
                    whoami: TRANSPORTER, // TODO: userbased handling
                    from: Moment(startDate).valueOf(),
                    to: Moment(endDate).valueOf(),
                    rfqType,
                    seekerCompanyId: getItemFromLocal('transporter_seeker_company_id')
                },
                onSuccess: this.setGetRFQTimer,
                onError: this.setGetRFQTimer
            });
        }
    }

    onRfqSearchByDate=(startDate, endDate)=>{
                    this.setState({
                        startDate,
                        endDate
                    },()=>{
                        this.search(this.state.offset);
                    })
        }
        onClearDate=()=> {
            this.setState({
                startDate:0,
                endDate:0
            }, this.search);
        }
    setGetRFQTimer = ()=> {
        this.getRFQTimer = setTimeout(()=> {
            this.search(this.state.offset)
        }, 10000);
    }
    changeRfqStatusFilter(value) {
        const { dispatch }= this.props;
        dispatch({
            type: CLEAR_RFQS
        });
        this.setState({rfqStatusFilter: value}, () => {
            this.updateQueryParams(this.state.searchString, value);
            this.setState({offset: 0, limit: 10}, () => {
                this.search();
            });
        });
    }
  
    
    goToNextPage() {
        this.setState({
            offset: this.state.offset + this.state.limit
        }, () => {
            this.search(this.state.offset);
        });
    }

    goToPrevPage() {
        if(this.state.offset != 0) {
            this.setState({
                offset: this.state.offset - this.state.limit
            }, () => {
                this.search(this.state.offset);
            });
        }
    }

	downloadServiceCategory = () => {
		const { dispatch } = this.props;
		dispatch({
            type: PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE,
            params: {
                companyId: 1782
            },
			onSuccess: ((data) => {
				this.setState({
					downlaadSCUrl :data.url
				}, () => {
                    this.downloadSC.click();
                })
			})
		})
	}

	uploadServiceCategory = (file) => {
		const { dispatch } = this.props;
		dispatch({
			type: PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE,
            file: file,
            onSuccess: this.getServiceCategory
		})

	}

    getServiceCategory = () => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_SERVICE_CATEGORY,
            params: {
                companyId: 1782
            }
        })
    }
    
    updateQueryParams(searchString, rfqStatusFilter) {
        const { history, location } = this.props;
        const params = new URLSearchParams(location.search);
        if (searchString) {
            params.set('search', searchString);
        } else {
            params.delete('search');
        }
        params.set('tab', rfqStatusFilter);
        history.replace({ search: params.toString() });
    }

    onSearchStringChange(e) {
            const value = e.currentTarget.value;
            this.setState({
                searchString: value,
                offset: 0,
                limit: 10
            }, () => {
                this.updateQueryParams(value, this.state.rfqStatusFilter);
                if (value.length >= 3 || value.length === 0) {
                    this.appliedSearch = value;
                    this.debouncedSearch();
                }
            });
    }

    onClearSearch() {
        this.appliedSearch = '';
        this.setState({ searchString: '' }, () => {
            this.updateQueryParams('', this.state.rfqStatusFilter);
            this.search();
        });
    }

    onRFQTypeSelect = (value) => {
        this.setState({
            rfqType: value.id
        },  this.search);
    }
    
    onKeyPressOnSearch(e) {
        if(e.which == 13) {
            // this.setState({offset: 0, limit: 10}, () => {
            //     this.search();
            // });
        }
    }
    pickupRfq = (rfq)=> {
        const { dispatch, history } = this.props
        dispatch({
            type: CREATE_RFQ_SUCCESS,
            rfq
        });
        history.push('/rfq/details');
    }
    componentDidMount() {
        const { dispatch } = this.props;
        dispatch({
            type: CLEAR_RFQS
        });
        dispatch({ type: GET_RFQ_TYPES });
        this.search();
    }
    componentWillUnmount() {
        this.unmounted = true;
        if(this.getRFQTimer) {
            clearTimeout(this.getRFQTimer);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.rfqs.data !== this.props.rfqs.data) {
            this.setState({
                data: nextProps.rfqs.data || []
            })
        }
    }

	downloadTrips = () => {
		const { dispatch, match, rfq } = this.props;

		dispatch({
			type: DOWNLOAD_TRIPS_TEMPLATE,
			params: {
				type: rfq.rfqDetails.serviceType === 3 ? 1 : 2,
				rfqId: match.params.id
			},
			onSuccess: (data) => {
				if (data.link !== this.state.uploadTripsUrl) {
					this.setState({
						uploadTripsUrl: data.link,
						isSuccessfull: true,
					});
				}
			}
		});
		setTimeout(() => {
			if (this.state.isSuccessfull) {
				this.uploadTripsButton.click();
			}
		}, 1000)

    }
    
    onChangeServiceAvailability = (data) => {
        this.setState({ confirmationData: data });
    }

    confirm = () => {
        const { dispatch } = this.props;
        const { confirmationData } = this.state;
        dispatch({
            type: UPDATE_SERVICE_CATEGORY,
            data: {
                service_availability_list: [confirmationData]
            },
            onSuccess: () => {
                this.onCancel();
                this.getServiceCategory();
            },
            onError: this.onCancel
        })
    }

    onCancel = () => {
        this.setState({
            confirmationData: ''
        })
    }

    onWishList = (rfq) => {
        const { dispatch } = this.props;
        dispatch({
            type: POST_WISHLIST_EVENT,
            data: {
                rfq_id: rfq.id,
                event_id: rfq.event_id
            },
            onSuccess: () => {
                this.search(this.state.offset);
            }
        })
    }

    render() {
    
        const { gettingRfqs, activeCount, biddingCount, loiCount } = this.props.rfqs;
        const { limit, offset, rfqStatusFilter, data, confirmationData, rfqType } = (this.state || {});
        const { systemTime, dataLoading, serviceCategoryList, rfqTypesList } = this.props;
        let commontabFilter = [{
                id:2,
                value: 'All Active',
                count: activeCount
            }
        ];

        const extraTabFilters = [
            {
                id:3,
                value: 'Bidding In Progress',
                count: biddingCount
            },{
                id:5,
                value: 'Closed',
                count: loiCount
            }
        ];
        // TODO: Temp fix. Do it better because filter is not making sense here!
        if(rfqStatusFilter == 1) {
            commontabFilter = [{
                id:1,
                value: 'All Drafts',
                count: data && data.length
            }]
        }
        if(rfqStatusFilter === 99) {
            commontabFilter = [{
                id:99,
                value: 'All Canceled RFQS',
                count: data && data.length
            }]
        }
        
        const tabFilter = (rfqStatusFilter == 1 ||rfqStatusFilter === 99)? commontabFilter : commontabFilter.concat(extraTabFilters); 
        const searchPlaceHolder = rfqStatusFilter != 6 ? "Search RFQ" : "Search Contracts";
        const showFilters = rfqStatusFilter != 6;
        return (
            <div>
                {
                    (gettingRfqs === true || dataLoading) && <ActionLoader fixed={true} />
                }
                <Sticky>
                    <ScreenTimeTrack
                        screenInfoDetailsItem={
                            screenInfoDetails.CONTRACTING_PROVIDER_HOME_SCREEN
                        }
                    />
                    <DashboardTopNav 
                    rfqStatusFilter={rfqStatusFilter} 
                    changeRfqStatusFilter={this.changeRfqStatusFilter}
                    tabFilter={tabFilter}
                    searchString={this.state.searchString}
                    onSearchStringChange={this.onSearchStringChange}
                    onKeyPressOnSearch={this.onKeyPressOnSearch}
                    searchPlaceHolder={searchPlaceHolder}
                    showFilters={showFilters}
                    onCancel={this.onClearSearch}
                    onRfqSearchByDate ={this.onRfqSearchByDate}
                    onCancelDate ={ this.onClearDate}
                    contracting={this.user.contracting}
                    />
                    
                    <div className="flex pt-80">
                        <Sidebar  
                            rfqStatusFilter={rfqStatusFilter} 
                            changeRfqStatusFilter={this.changeRfqStatusFilter} 
                            broadcastMsgs={this.props.broadcastMsgs}
                        />
                        <div className="flex-basis-20p" />
                        <div className="fluid-container ml-20">
                        {gettingRfqs  && <ActionLoader fixed={true}/> }
                        {
                            <AllRfqs rfqs={data}  
                                searchString={this.state.searchString}
                                history={this.props.history}
                                status={this.state.rfqStatusFilter}
                                goToNextPage={this.goToNextPage}
                                goToPrevPage={this.goToPrevPage}
                                limit={limit}
                                offset={offset}
                                pickupRfq = {this.pickupRfq}
                                systemTime={systemTime}
                                gettingRfqs={gettingRfqs}
								downloadServiceCategory={this.downloadServiceCategory}
								downloadUrl={this.state.downloadUrl}
                                uploadServiceCategory={this.uploadServiceCategory}
                                serviceCategoryList={serviceCategoryList}
                                onChangeServiceAvailability={this.onChangeServiceAvailability}
                                onRFQTypeSelect={this.onRFQTypeSelect}
                                rfqTypesList={rfqTypesList}
                                rfqType={rfqType}
                                onWishList={this.onWishList}
                            />
                        }
                        </div>
                    </div>
                    <a href={this.state.downlaadSCUrl} className="dNone" ref={(ref) => { this.downloadSC = ref; }}>Service Category</a>
                    {confirmationData &&
                        <ConfirmationPopup
                            text={'Are You Sure?'}
                            onConfirm={this.confirm}
                            onCancel={this.cancel}
                        />
                    }
                </Sticky>
            </div>
        );
  }
}

const mapStateToProps = ({rfq, common, constants }) => {
  return {
    rfqs: rfq.rfqs,
    systemTime: common.systemTime,
    serviceCategoryList: rfq.serviceCategory.data || [],
    dataLoading: rfq.serviceCategory.dataLoading,
    rfqTypesList: constants.rfqTypes || [],
    broadcastMsgs: common.broadcastMsgs || []
  };
};


export default connect(mapStateToProps)(Dashboard);
